var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElement1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.817 30.8433L19.8216 20.5456C19.8781 20.1524 20.1972 19.7971 20.6101 19.7226L30.9314 19.7341C31.3255 19.7907 31.6447 19.4353 31.72 18.9111L31.7413 13.1631C31.7978 12.77 31.4413 12.4513 30.9159 12.3759L20.5946 12.3644C20.2005 12.3078 19.8441 11.9891 19.7693 11.5771L19.7738 1.27937C19.8302 0.886248 19.4738 0.567556 18.9484 0.492081L13.1872 0.466976C12.7931 0.410369 12.474 0.765751 12.3987 1.28992L12.3942 11.5877C12.3377 11.9808 12.0185 12.3362 11.6056 12.4106L1.28426 12.3991C0.890202 12.3425 0.571022 12.6979 0.495726 13.2221L0.474391 18.9701C0.417919 19.3632 0.77435 19.6819 1.29977 19.7574L11.6211 19.7688C12.0152 19.8254 12.3716 20.1441 12.4465 20.5561L12.4419 30.8538C12.3855 31.247 12.7419 31.5656 13.2673 31.6411L19.0285 31.6662C19.4414 31.5918 19.7605 31.2364 19.817 30.8433Z",
    fill: "#FDD08D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement1);
export default __webpack_public_path__ + "static/media/element1.f7b837c32be59fbeecaef7744eb62eb0.svg";
export { ForwardRef as ReactComponent };